
import { GET_VIEWERS_CART_SUMMARY_QUERY } from '@marketplace/graphql/cart.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'
import { mapGetters } from 'vuex'

export default {
    name: 'HeaderCart',

    computed: {
        ...mapGetters('global', ['cartProductsCount']),

        // Display total products count with a maximum of 99+
        cartProductsTotalCountDisplay() {
            if (this.cartProductsCount <= 0) {
                return false
            }

            if (this.cartProductsCount < 100) {
                return this.cartProductsCount
            }

            return '99+'
        },
    },

    mounted() {
        EventBus.$on('refresh-popup-cart-data', this.fetchCartSummary)
        EventBus.$on('show-header-cart', this.productAddedToCart)
    },

    beforeDestroy() {
        EventBus.$off('refresh-popup-cart-data', this.fetchCartSummary)
        EventBus.$off('show-header-cart', this.productAddedToCart)
    },

    methods: {
        async fetchCartSummary() {
            if (!this.$helpers.isLoggedIn) {
                return null
            }

            const { data } = await this.$apollo.query({
                query: GET_VIEWERS_CART_SUMMARY_QUERY,
                fetchPolicy: 'network-only',
            })

            const summary = data?.summary
            if (summary) {
                this.$store.commit(
                    'global/updateCartProductsCount',
                    summary.totalProductsInCartCount || 0
                )
                this.$store.commit('cart/updateCartSummaryData', summary)
            }

            return summary
        },

        async productAddedToCart() {
            await this.fetchCartSummary()

            if (this.$page.isStorefrontRelatablePage) {
                EventBus.$emit('updateSideCart')
            } else {
                this.$emit('productAddedToCart')
            }
        },
    },
}
